{
  "origin": "https://sohtinyhouse.com",
  "name": "SOH Tiny House",
  "image": "/assets/picaroo/1_2400x1714.webp",
  "pages": [
    {
      "id": "home",
      "path": "/",
      "enPath": "/en"
    },
    {
      "id": "about",
      "path": "/about",
      "enPath": "/en/about"
    },
    {
      "id": "contact",
      "path": "/contact",
      "enPath": "/en/contact"
    },
    {
      "id": "surroundings",
      "path": "/imprejurimi",
      "enPath": "/en/surroundings"
    }
  ]
}
